import Cfg from '../config/cfg';

export default {
  _deferredCtxInit: false,
  autoInitCtxManager: function(){
    if(this._deferredCtxInit){
      return;
    }
    this._deferredCtxInit = true;
    Flybits.Session.ready.then(function(){
      if(typeof window.Flybits === 'object' && !Flybits.context.Manager.isReporting){
        Flybits.context.Manager.reportDelay = Cfg.DEFAULTCTXREPORTINTERVAL;
        Flybits.context.Manager.initialize();
      }
    });
  },
  handleContextPayload: function(payload, logger){
    logger = logger || console;
    if(Array.isArray(payload)){
      Flybits.context.Manager.ready.then(function(){
        payload.forEach(function(ctxRep){
          if(ctxRep.pluginId && ctxRep.values){
            var cleansedValueObj = {};
            Object.keys(ctxRep.values).forEach(function(key){
              var cleansedKeyStr = key.replaceAll('query.','');
              cleansedValueObj[cleansedKeyStr] = ctxRep.values[key];
            });
            Flybits.context.Manager.reportCtx(ctxRep.pluginId,cleansedValueObj);
          } else{
            logger.error('[ctxapi] malformed ctx payload object', payload);      
          }
        })
      })
    } else{
      logger.error('[ctxapi] malformed ctx payload', payload);
    }
  },
  handleAnalyticsPayload: function(payload, logger){
    logger = logger || console;
    if(!payload?.contentInfo?.id){
      logger.error('[ctxapi] missing content id in analytics event');
      return;
    }

    if((payload.type === 'viewed' || payload.type === 'engaged') && !payload.component){
      Flybits.context.Manager.ready.then(function(){
        Flybits.analytics.Manager.reportContentID(payload.contentInfo.id,payload.type);
      });
    } else if((payload.type === 'engaged' || payload.type === 'content_component_event') && payload.component){
      Flybits.context.Manager.ready.then(function(){
        Flybits.analytics.Manager.reportContentID(payload.contentInfo.id, Flybits.analytics.Manager.actions.COMPONENTENGAGED,{
          name: payload.component.name,
          compID: payload.component.id,
          type: payload.component.compId,
        });
      });
    } else{
      logger.error('[ctxapi] unsupported analytics event', payload);
    }
  }
}